import React from 'react'
import { RequestSignatureDetailView } from '../../views'
import { LocalStorageService, UserService, SignerService, PlanService, SignatureTypesService, SignatureReceiveService, SignatureRequestService } from '../../../services/index'
import { withTranslation } from 'react-i18next'
import { SignatureRequestValidator } from "../../../validators/index"
import { process as processKendo } from '@progress/kendo-data-query'
import moment from 'moment'
import { getNavigatorTimezone } from '../../../utils'


class RequestSignatureDetailAction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            skip: 0,
            take: 6,
            group: '',
            sort: [],
            total: 0,
            requests: [],
            loading: false,
            dateFrom: '',
            dateTo: '',
            date: new Date(),
            nameSign: '',
            signRequestStatusId: null,
            signRequestStatus: props.t("requestSignatureDetailView.checkboxAll"),
            signerEmail: '',
            signatureTypeId: null,
            all: true,
            eSign: false,
            autograph: false,
            electronic: false,
            onFilter: false,
            title: props.t('requestSignatureDetailView.titleRequestSignature'),
            description: props.t('requestSignatureDetailView.description'),
            titleFilter: props.t('requestSignatureDetailView.titleRequestSignatureFilter'),
            descriptionFilter: props.t('requestSignatureDetailView.descriptionFilter'),
            signers: [],
            signerInEdit: undefined,
            token: "",
            collaboratorListAllow: [],
            inviteListAllow: [],
            user: null,
            showPagination: { info: false },
            email: '',
            errorDateFrom: false,
            errorDateTo: false,
            messageErrorDateFrom: '',
            messageErrorDateTo: '',
            isHideTrash: true,
            signatureRequests: [],
            offset: 0,
            limit: +process.env.REACT_APP_OFFSET_LIMIT_REQUEST,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            showWarningRequesting: false,
            messageError: '',
            messageComplete: '',
            messageWarning: '',
            makeRequest: true,
        }
    }

    signRequestStatusData = [
        { status: this.props.t("requestSignatureDetailView.status.all") },
        { status: this.props.t("requestSignatureDetailView.status.pending") },
        { status: this.props.t("requestSignatureDetailView.status.completed") },
        { status: this.props.t("requestSignatureDetailView.status.rejected") },
        { status: this.props.t("requestSignatureDetailView.status.canceled") }
    ]
    token = {}
    user = {}
    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    userService = new UserService(this.url)
    signerService = new SignerService(this.url)
    planService = new PlanService(this.url)
    signatureTypesService = new SignatureTypesService(this.url)
    signatureReceiveService = new SignatureReceiveService(this.url)
    signatureRequestService = new SignatureRequestService(this.url)
    validator = SignatureRequestValidator(this.props.t)
    timezone = getNavigatorTimezone()

    async componentDidMount() {
        this.setState({ loading: true })
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')

        try {
            let userContractPlan = await this.planService.getUserContractAndPlan(this.token)
            let signatureTypes = await this.signatureTypesService.getSignatureTypes(this.token)
            // let requests = [this.localStorageService.getLocalStorageItem('requests')]
            // let filter = this.localStorageService.getLocalStorageItem('filter')
            let requests = []
            let usersCollabotartorInvites = await this.userService.getUsersCollaboratorInvite(this.token)
            if (!usersCollabotartorInvites) {
                usersCollabotartorInvites.usersCollaborator = []
                usersCollabotartorInvites.usersInvite = []
            }

            this.localStorageService.setLocalStorageItem('userContractPlan', userContractPlan)
            this.localStorageService.setLocalStorageItem('signatureTypes', signatureTypes)

            this.setState({
                token: this.token,
                collaboratorListAllow: usersCollabotartorInvites.usersCollaborator,
                inviteListAllow: usersCollabotartorInvites.usersInvite,
                loading: false,
                user: this.user
            })

            // if (filter) {
            //     this.setLimitOffset()
            //     this.setState({
            //         dateFrom: filter.dateFrom ? new Date(filter.dateFrom) : '',
            //         dateTo: filter.dateTo ? new Date(filter.dateTo) : '',
            //         nameSign: filter.nameSign || '',
            //         signRequestStatus: filter.signRequestStatus || null,
            //         signatureTypeId: filter.signatureTypeId || null,
            //         signerEmail: filter.signerEmail || '',
            //         all: (!filter.eSign && !filter.autograph && !filter.electronic) ? true : false,
            //         eSign: filter.eSign || false,
            //         autograph: filter.autograph || false,
            //         electronic: filter.electronic || false,
            //     })
            // }else{
            // }
            let today = new Date()
            let dayPreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.setState({
                dateFrom: dayPreviousMonth,
                dateTo: today
            })
            this.onSubmitSignatureFilter(null, true)

            if (userContractPlan && signatureTypes && requests) {
                let userType = this.user.userMetaData.userMifirma.userType
                let userMiFirmaId = this.user.userMetaData.userMifirma.id
                if (requests && requests.length > 0) {
                    requests = requests.map((request) => {
                        let arraySignRequestExpirationDate = request.expirationDate.split('/')
                        let dateParseExpirationDate = arraySignRequestExpirationDate[0] + '/' + moment(arraySignRequestExpirationDate[1]).format('MMMM') + '/' + arraySignRequestExpirationDate[2]
                        request.expirationDate = dateParseExpirationDate

                        let arraySignRequestCreatedDate = request.createdDate.split('/')
                        let dateParseCreatedDate = arraySignRequestCreatedDate[0] + '/' + moment(arraySignRequestCreatedDate[1]).format('MMMM') + '/' + arraySignRequestCreatedDate[2]
                        request.createdDate = dateParseCreatedDate
                        return request
                    })
                } else {
                    requests = []
                }
                if (!userContractPlan.data) {
                    return this.setState({
                        signatureRequests: requests,
                        total: requests.length,
                        requests,
                        signatureTypes: (signatureTypes) ? signatureTypes : {},
                        userType: (userType) ? userType : {},
                        contractPlanExist: false,
                        initialLoading: false,
                        loading: false,
                        onFilter: true,
                    }, () => {
                        this.onChangeFooterInfoPagination(this.state.requests, this.state.take, this.state.skip)
                    })
                } else {
                    let { contract, plan } = userContractPlan.data
                    let dateExpiration = contract.endOfContract.split('T')[0]

                    return this.setState({
                        skip: 0,
                        take: 6,
                        signatureRequests: requests,
                        total: requests.length,
                        requests,
                        signatureTypes: (signatureTypes) ? signatureTypes : {},
                        userType: (userType) ? userType : {},
                        userMiFirmaId: (userMiFirmaId) ? userMiFirmaId : '',
                        initialLoading: false,
                        contractPlanExist: true,
                        planName: plan.name,
                        signsAvailable: contract.availableTransaction,
                        totalSigns: contract.annualTransaction,
                        expirationDate: moment(dateExpiration).format('DD/MMMM/YYYY'),
                        createdDate: moment(dateExpiration).format('DD/MMMM/YYYY'),
                        monthlyTransactions: contract.monthlyTransaction,
                        pricing: contract.pricing,
                        buttonFilterSelectedBlue: 'table-button-blue-active',
                        buttonFilterSelectedGreen: '',
                        loading: false,
                        onFilter: true,
                    }, () => {
                        this.onChangeFooterInfoPagination(this.state.requests, this.state.take, this.state.skip)
                    })
                }

            }
        } catch (error) {
            console.log(error)
            this.setState({
                initialLoading: false,
            })
        }
    }

    scrollWindow = () => {
        window.scrollTo(0, 0)
    }

    onChange = (event, name) => {
        let target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value

        this.setState({
            [name]: value
        })
    }

    //CHECKBOX
    onAcceptAll = (event) => {
        this.setState({ all: event ? event.target.checked : !this.state.all, eSign: false, electronic: false, autograph: false, signatureTypeId: null })
    }
    onAcceptESignature = (event) => {
        this.setState({ eSign: event ? event.target.checked : !this.state.eSign, all: false, electronic: false, autograph: false, signatureTypeId: 1 })
    }
    onAcceptElectronicSignature = (event) => {
        this.setState({ electronic: event ? event.target.checked : !this.state.electronic, all: false, eSign: false, autograph: false, signatureTypeId: 2 })
    }
    onAcceptAutographSignature = (event) => {
        this.setState({ autograph: event ? event.target.checked : !this.state.autograph, all: false, eSign: false, electronic: false, signatureTypeId: 3 })
    }
    ////

    onChangeComboBox = (event) => {
        let value = event.target.value
        this.setState({
            signRequestStatus: value,
            value: value,
        })
    }

    onReturn = () => {
        this.setState({
            onFilter: false
        })
    }

    onChangeAutoComplete = (value) => {
        this.setState({
            signerEmail: value,
        })
    }
    onSubmitSignatureFilter = async (event, firstSearch) => {
        if (event) event.preventDefault();
        let messageError = this.props.t("requestSignatureDetailView.errors.general.consult")
        this.toggleLoadingRequesting(true)

        let dateFrom = this.state.dateFrom || null
        let dateTo = this.state.dateTo || null
        let nameSign = this.state.nameSign || null

        if (dateFrom === null || dateFrom === "") {
            this.setState({
                errorDateFrom: true,
                messageErrorDateFrom: this.props.t("requestSignatureDetailView.errors.obligatory.fields")
            })
            return false
        } else {
            this.setState({
                errorDateFrom: false,
                messageErrorDateFrom: ''
            })
        }
        if (dateTo === null || dateTo === "") {
            this.setState({
                errorDateTo: true,
                messageErrorDateTo: this.props.t("requestSignatureDetailView.errors.obligatory.fields")
            })
            return false
        } else if (dateFrom > dateTo) {
            this.setState({
                errorDateFrom: true,
                errorDateTo: false,
                messageErrorDateFrom: this.props.t("requestSignatureDetailView.errors.finish.date.wrong")
            })
            return false
        } else {
            this.setState({
                errorDateTo: false,
                messageErrorDateTo: ''
            })
        }

        let signRequestStatusId
        let signRequestStatus = this.state.signRequestStatus
        switch (signRequestStatus) {
            case this.props.t("requestSignatureDetailView.status.pending"):
                signRequestStatusId = 2
                break
            case this.props.t("requestSignatureDetailView.status.completed"):
                signRequestStatusId = 4
                break
            case this.props.t("requestSignatureDetailView.status.rejected"):
                signRequestStatusId = 3
                break
            case this.props.t("requestSignatureDetailView.status.canceled"):
                signRequestStatusId = 5
                break
        }

        let signerEmail = this.state.signerEmail
        let signatureTypeId = this.state.signatureTypeId
        let all = this.state.all
        let eSign = this.state.eSign
        let autograph = this.state.autograph
        let electronic = this.state.electronic
        let timezone = this.timezone
        let offset = (firstSearch) ? 0 : this.state.offset
        let limit = this.state.limit
        let filter = { dateFrom, dateTo, nameSign, signRequestStatusId, signerEmail, signatureTypeId, signRequestStatus, all, eSign, autograph, electronic, timezone, offset, limit }

        try {
            let requests = await this.signerService.getFilterSign(filter, this.token)
            let userType = this.user.userMetaData.userMifirma.userType
            let userMiFirmaId = this.user.userMetaData.userMifirma.id
            let allRequests = (firstSearch) ? requests : this.state.signatureRequests.concat(requests)

            let userContractPlan = this.localStorageService.getLocalStorageItem('userContractPlan')
            let signatureTypes = this.localStorageService.getLocalStorageItem('signatureTypes')
            // this.localStorageService.setLocalStorageItem('requests', allRequests)
            // this.localStorageService.setLocalStorageItem('filter', filter)

            this.setState({
                skip: 0,
                take: allRequests.length,
            })

            if (requests && requests.length > 0) {
                requests = requests.map((request) => {
                    request.createdDateBD = request.createdDate
                    let arraySignRequestExpirationDate = request.expirationDate.split('/')
                    let dateParseExpirationDate = arraySignRequestExpirationDate[0] + '/' + moment(arraySignRequestExpirationDate[1]).format('MMMM') + '/' + arraySignRequestExpirationDate[2]
                    request.expirationDate = dateParseExpirationDate

                    let arraySignRequestCreatedDate = request.createdDate.split('/')
                    let dateParseCreatedDate = arraySignRequestCreatedDate[0] + '/' + moment(arraySignRequestCreatedDate[1]).format('MMMM') + '/' + arraySignRequestCreatedDate[2]
                    request.createdDate = dateParseCreatedDate
                    return request
                })
                this.setLimitOffset()
            } else {
                if (!firstSearch) {
                    allRequests = this.state.signatureRequests
                    requests = this.state.signatureRequests

                } else {
                    requests = []
                }
                this.setMakeRequest(false)
            }

            this.toggleLoadingRequesting(false)
            // if(!requests || (requests && requests.length === 0)) this.setMakeRequest(false)

            if (!userContractPlan.data) {
                return this.setState({
                    signatureRequests: allRequests,
                    total: requests.length,
                    requests: allRequests,
                    signatureTypes: (signatureTypes) ? signatureTypes : {},
                    userType: (userType) ? userType : {},
                    contractPlanExist: false,
                    initialLoading: false,
                    onFilter: true,
                }, () => {
                    this.onChangeFooterInfoPagination(this.state.requests, this.state.take, this.state.skip)
                })
            } else {
                let { contract, plan } = userContractPlan.data
                let dateExpiration = contract.endOfContract.split('T')[0]

                return this.setState({
                    signatureRequests: allRequests,
                    total: requests.length,
                    requests,
                    signatureTypes: (signatureTypes) ? signatureTypes : {},
                    userType: (userType) ? userType : {},
                    userMiFirmaId: (userMiFirmaId) ? userMiFirmaId : '',
                    initialLoading: false,
                    contractPlanExist: true,
                    planName: plan.name,
                    signsAvailable: contract.availableTransaction,
                    totalSigns: contract.annualTransaction,
                    expirationDate: moment(dateExpiration).format('DD/MMMM/YYYY'),
                    createdDate: moment(dateExpiration).format('DD/MMMM/YYYY'),
                    monthlyTransactions: contract.monthlyTransaction,
                    pricing: contract.pricing,
                    buttonFilterSelectedBlue: 'table-button-blue-active',
                    buttonFilterSelectedGreen: '',
                    onFilter: true
                }, () => {
                    this.onChangeFooterInfoPagination(this.state.requests, this.state.take, this.state.skip)
                })
            }

        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }

    }

    //Signature recieve panel action?
    edit = (dataItem) => {
        this.setState({
            signatureRequestInEdit: this.cloneSignatureRequest(dataItem)
        })
    }

    cloneSignatureRequest(signatureRequest) {
        return Object.assign({}, signatureRequest);
    }

    processNewState = (dataState) => {
        let copyState = JSON.parse(JSON.stringify(dataState));
        if (copyState && copyState.sort && copyState.sort.length > 0 && copyState.sort[0].field && copyState.sort[0].field === "startDate") copyState.sort[0].field = "startDateSearch"
        if (copyState && copyState.sort && copyState.sort.length > 0 && copyState.sort[0].field && copyState.sort[0].field === "limitDate") copyState.sort[0].field = "limitDateSearch"

        let response = processKendo(this.state.requests.slice(0), copyState)
        return {
            signatureRequests: response.data,
            total: response.total
        }
    }

    dataStateChange = (event) => {
        let { signatureRequests, total } = this.processNewState(event.dataState)
        this.setState({
            signatureRequests,
            total,
            filter: (event.dataState.filter ? event.dataState.filter : undefined),
            group: (event.dataState.group ? event.dataState.group : undefined),
            sort: (event.dataState.sort ? event.dataState.sort : []),
            skip: event.dataState.skip,
            take: event.dataState.take
        }, () => {
            this.onChangeFooterInfoPagination(this.state.requests, this.state.take, this.state.skip)
        })
    }

    onChangeFooterInfoPagination = (elements, take, skip) => {
        let showPagination = false;
        let paginationInfoExist = document.querySelector('#infoPaginationSignRequestReceive')

        if (paginationInfoExist) {
            paginationInfoExist.remove()
            showPagination = false
        }

        let totalItemsInTable = elements.length

        if (elements.length !== 0) {
            showPagination = { info: false }
            let currentPage = Math.floor(skip / take) + 1;
            let totalPages = Math.ceil((totalItemsInTable || 0) / take)

            let firstItemInPage = (skip + 1)
            let lastItemInPage = 0
            if (currentPage === totalPages) {
                lastItemInPage = totalItemsInTable
            } else {
                lastItemInPage = (skip + take)
            }

            let footerPagination = document.querySelector("div[role='navigation']")
            if (footerPagination) {
                let element = document.createElement('div')
                element.id = 'infoPaginationSignRequestReceive'
                element.innerHTML = `<span>${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Solicitudes</span> <span style="margin-left: 30px;">${currentPage}/${totalPages}</span>`
                element.className = 'k-pager-info k-label'
                footerPagination.appendChild(element)
            }
        } else {
            showPagination = false
        }

        return showPagination
    }


    scrollWindow = () => {
        window.scrollTo(0, 0)
    }

    handleScrollRequest = () => {
        if (!this.state.makeRequest) return
        this.onSubmitSignatureFilter()
    }

    setLimitOffset = (reset) => {
        let offset = this.state.offset + this.state.limit

        if (reset) {
            offset = 0
        }

        this.setState({
            offset
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    window.location.replace(sendTo)
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
            messageComplete: message || ''
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                    messageComplete: ''
                })
                if (sendInbox) {
                    window.location.replace(sendTo)
                }
            }, time || 4000)
        })
    }

    toggleWarningRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showWarningRequesting: true,
            messageWarning: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showWarningRequesting: false,
                    messageWarning: ''
                })
                if (sendInbox) {
                    window.location.replace(sendTo)
                }
            }, time || 4000)
        })
    }

    setMakeRequest = (makeRequest) => {
        this.setState({
            makeRequest
        })
    }

    onHandleSearch = (e) => {
        this.setLimitOffset(true)
        this.setMakeRequest(true)
        this.onSubmitSignatureFilter(e, true)
    }

    render() {
        return (
            <RequestSignatureDetailView
                {...this.state}
                onChange={this.onChange}
                onChangeComboBox={this.onChangeComboBox}
                onChangeCheckBox={this.onChangeCheckBox}
                changeSignerInEdit={this.changeSignerInEdit}
                validator={this.validator}
                signRequestStatusData={this.signRequestStatusData}
                onAcceptAutographSignature={this.onAcceptAutographSignature}
                onAcceptElectronicSignature={this.onAcceptElectronicSignature}
                onAcceptESignature={this.onAcceptESignature}
                onAcceptAll={this.onAcceptAll}
                onChangeAutoComplete={this.onChangeAutoComplete}

                edit={this.edit}
                cloneSignatureRequest={this.cloneSignatureRequest}

                dataStateChange={this.dataStateChange}

                onSubmitSignatureFilter={this.onSubmitSignatureFilter}
                onReturn={this.onReturn}

                handleScrollRequest={this.handleScrollRequest}

                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleWarningRequesting={this.toggleWarningRequesting}
                onHandleSearch={this.onHandleSearch}
            />
        )

    }
}


export default withTranslation()(RequestSignatureDetailAction)

